import * as React from 'react';
import { Image, View } from 'react-native';
import { cn } from '@/lib/utils';
import { Text } from './text';

type AvatarProps = React.ComponentPropsWithoutRef<typeof View>;

const Avatar = React.forwardRef<React.ElementRef<typeof View>, AvatarProps>(
  ({ className, ...props }, ref) => (
    <View
      ref={ref}
      className={cn(
        'relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full',
        className
      )}
      {...props}
    />
  )
);
Avatar.displayName = 'Avatar';

type AvatarImageProps = React.ComponentPropsWithoutRef<typeof Image>;

const AvatarImage = React.forwardRef<React.ElementRef<typeof Image>, AvatarImageProps>(
  ({ className, ...props }, ref) => {
    const [hasError, setHasError] = React.useState(false);

    if (hasError) {
      return null;
    }
    return (
      <Image
        ref={ref}
        onError={() => setHasError(true)}
        className={cn('aspect-square h-full w-full', className)}
        {...props}
      />
    );
  }
);
AvatarImage.displayName = 'AvatarImage';

type AvatarFallbackProps = React.ComponentPropsWithoutRef<typeof View> & {
  textClassName?: string;
};

const AvatarFallback = React.forwardRef<React.ElementRef<typeof View>, AvatarFallbackProps>(
  ({ children, className, textClassName, ...props }, ref) => (
    <View
      ref={ref}
      className={cn(
        'flex h-full w-full items-center justify-center rounded-full bg-muted',
        className
      )}
      {...props}
    >
      <Text className={cn('text-lg font-medium text-muted-foreground', textClassName)}>
        {children}
      </Text>
    </View>
  )
);
AvatarFallback.displayName = 'AvatarFallback';

export { Avatar, AvatarImage, AvatarFallback };
export type { AvatarProps, AvatarImageProps, AvatarFallbackProps };

